<p-progressSpinner *ngIf="isLoading$ | async"></p-progressSpinner>
<div *ngIf="(isLoading$ | async) === false">
  <div *ngIf="content" id="json_code" class="code" styleClass='preview'>
    <pre><code [highlight]="content"></code></pre>
  </div>
</div>
